"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TealiumProvider = exports.TealiumContext = exports.TealiumConsumer = void 0;

var _react = require("react");

var _TealiumUniversalTag = _interopRequireDefault(require("../lib/TealiumUniversalTag"));

var _withGlobalData = _interopRequireDefault(require("./withGlobalData"));

var _events = require("./events");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TealiumContext = /*#__PURE__*/(0, _react.createContext)({});
exports.TealiumContext = TealiumContext;
var TealiumConsumer = TealiumContext.Consumer;
exports.TealiumConsumer = TealiumConsumer;

var TealiumProvider = function TealiumProvider(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  if (typeof window !== "undefined") {
    var disableTealiumInjectedInlinkOutlinkTracking = {
      tealiumInjectedInlinkOutlinkTracking: "tealium-universal-tag-context"
    }; // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-explicit-any

    window.tealiumMousedownEventListener = disableTealiumInjectedInlinkOutlinkTracking;
  }

  var tealium = (0, _react.useMemo)(function () {
    return new _withGlobalData.default(new _TealiumUniversalTag.default(_objectSpread({
      manualPageView: true
    }, props)));
  }, Object.values(props));
  (0, _events.useEventHandlers)(tealium);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(TealiumContext.Provider, {
    value: tealium,
    children: children
  });
};

exports.TealiumProvider = TealiumProvider;
//# sourceMappingURL=context.js.map